import script from "./ArrowContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArrowContent.vue?vue&type=script&setup=true&lang=ts"

import "./ArrowContent.vue?vue&type=style&index=0&id=69938cda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69938cda"]])

export default __exports__